<template>
  <div :class="$style.project_page">
    <stub />

    <!-- <kanban v-if="mode==='board'" /> -->
    <Board v-if="mode==='board'" />
    <list-view v-if="mode==='list'" />

    <workload v-if="mode==='workload'" />
    <resources v-if="mode==='resources'" />
    <overview v-if="mode==='overview'" />
    <calendar v-if="mode==='calendar'" />
    <export v-if="mode==='export'" />
    <history v-if="mode==='history'" />
    <gantt-view
      v-if="mode==='gantt'"
      :key="ganttViewKey"
      @ready="initGanttInstance"
    />

    <vgp-core-popup
      :show="showBudgetModeConfirm"
      :title="autoBudgetNewValue ? locale('budget_auto_mode_change_title') : locale('budget_manual_mode_change_title')"
      :close-icon="false"
      :buttons-switch="true"
      :ok-button-title="locale('common_confirm')"
      :cancel-button-title="locale('common_cancel')"
      :footer-style="'flex-end'"
      @onClickCancel="toggleAutoBudgetPopup"
      @onClickOk="applyAutoBudget"
    >
      <template #body>
        <div :class="$style.budget_mode_confirm_wrapper">
          <div :class="$style.confirm_message">
            {{ autoBudgetNewValue ? locale('budget_auto_mode_confirm_message') : locale('budget_manual_mode_confirm_message') }}
          </div>
          <div
            v-if="!autoBudgetNewValue"
            :class="$style.clear_costs_switcher"
          >
            <vgp-checkbox
              :class="$style.checkbox"
              :size="16"
              :checked="clearCosts"
              @onClick="clearCosts = !clearCosts"
            />
            <div
              :class="$style.checkbox_label"
              @click="clearCosts = !clearCosts"
            >
              {{ locale('budget_delete_costs_values') }}
            </div>
          </div>
        </div>
      </template>
    </vgp-core-popup>

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import routerGuard from '../../router/guards';
import projectsModel from '$$projectModel';
// import Kanban from '../kanban/Kanban.vue';
import Board from '../board/Board.vue';
import Workload from './workloadPage/workload.vue';
import Export from '../export/Export.vue';
import ProjectOverview from '../overview/ProjectOverview.vue';
import ProjectResources from '../resources/main.vue';
import listView from '../listView/listView.vue';
import ganttView from '../ganttView/ganttView.vue';
import ganttViewConstructor from '../ganttView/init';
import stub from '../stubs/stubPage.vue';
import calendar from '../calendarView/main.vue';
import app from '$$app';
import constants from '$$helpers/constants';
import History from '../history/History.vue';

export default {
  name: 'ProjectPage',

  components: {
    // kanban: Kanban,
    workload: Workload,
    export: Export,
    resources: ProjectResources,
    'list-view': listView,
    overview: ProjectOverview,
    'gantt-view': ganttView,
    stub,
    calendar,
    Board,
    history: History,
  },
  beforeRouteUpdate: routerGuard.guard,
  props: {
    mode: {
      type: String,
      default: 'gantt',
    },
  },

  data() {
    return {
      locale: __,
      showBudgetModeConfirm: false,
      clearCosts: false,
      autoBudgetNewValue: false,
      listeners: [],
    };
  },
  watch: {
    mode(mode) {
      if (mode === 'export') {
        this.$store.commit('setAppMode', constants.APP_MODES.EXPORT);
      }

      if (mode === 'gantt') {
        this.$store.commit('setAppMode', constants.APP_MODES.BASE);
      }
      projectsModel.setActiveProjectMode(mode);
    },
    '$route.params.projectId': function (value, oldValue) {
      if (+value !== +oldValue) {
        projectsModel.setActiveProject(+value, false, true);
        oldValue && this.$store.commit('setShowGrid', true);
      }
    },
  },
  beforeCreate() {
    if (this.$route.params.projectId) {
      projectsModel.setActiveProject(+this.$route.params.projectId, false, true);
    }

    this.$store.commit('setAppMode', constants.APP_MODES.BASE);
    this.$store.commit('setShowGrid', true);
  },
  mounted() {
    this.listeners.push(app.on('setting:autoBudget:showConfirm', autoBudgetNewValue => {
      this.autoBudgetNewValue = autoBudgetNewValue;
      this.toggleAutoBudgetPopup();
    }));
    this.listeners.push(app.on('project:archive', (ganttId, flag) => {
      const routeParams = this.$store.getters['headerView/currentRoute'].params;

      if (+routeParams.projectId === +ganttId && routeParams.mode === 'gantt') {
        ganttViewConstructor.initGanttInstance(ganttId);
      }
    }));

    projectsModel.setActiveProjectMode(this.mode); // init render
  },
  beforeUnmount() {
    this.listeners.forEach(id => app.off(id));
    this.listeners = [];
  },
  computed: {
    ...mapGetters('board', {
      isBoardConfigLoading: 'isLoading',
    }),
    ganttViewKey() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    toggleAutoBudgetPopup() {
      if (!this.showBudgetModeConfirm) {
        this.clearCosts = false;
      }

      this.showBudgetModeConfirm = !this.showBudgetModeConfirm;
    },
    applyAutoBudget() {
      userExtAnalytics.log('budget_calculation_mode_switch', {
        mode: this.autoBudgetNewValue ? 'auto' : 'manual',
        clearCosts: this.clearCosts,
      });
      this.$store.dispatch('tasksModel/updateTasksBudgetAndCost', {
        status: this.autoBudgetNewValue,
        isDeleteTask: this.clearCosts,
        projectId: this.$route.params.projectId,
        projectTasks: this.$store.getters['tasksModel/getTasksByGanttIds']([this.$route.params.projectId]),
      });
      this.toggleAutoBudgetPopup();
    },
    initGanttInstance() {
      ganttViewConstructor.initGanttInstance(+this.$route.params.projectId);
    },
  },
};
</script>

<style module src="./less/projectPage.less">

</style>
